export default __webpack_public_path__ + "static/media/red-delete-icon.36c3b15a.svg";